import ApiGenericServicesData from "service/ApiGenericServicesData";

export default class PaquetesDeAfiliacionYAdhesion extends ApiGenericServicesData {
    constructor() {
        super("paquetesDeAfiliacionYAdhesion");
    }

    getDetailPackageOp(idPackage) {
        return this.customGET("listarHojasEnPaquete/" + idPackage);
    }

    getListPackageOp(idOp, idEstadoPaquete, faseOp) {
        return this.customGET("list/" + idOp + "/" +idEstadoPaquete + "/" + faseOp);
    }

    eliminarPaquete(idPaquete) {
        return this.customPOST("delete/" + idPaquete);
    }


    crearPaquete(data) {
        return this.customPOST("create/", data);
    }

    editName(data) {
        return this.customPOST("updateName/", data)
    }

    enviarPaquete(idPaquete) {
        return this.customPOST("send/" + idPaquete);
    }

    agregarPaqueteExistente(id, data) {
        return this.customPOST("update/" + id, data);
    }

    generarReporte(data) { return this.customPOST("reporte/resumenDepuracionDeHojas", data); }

    openConstanciaEnvio(idPaquete) { return this.customGET("openFile/" + idPaquete); }

    openFile(CVE, ruta) { return this.customGET("openfile/" + ruta + '/' + CVE); }


}